import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { queryClient } from './lib/query-client';
import { BrandingProvider } from './lib/branding-context';
import { ThemeProvider } from './lib/theme-context';
import { MeasurementProvider } from './lib/measurement-context';
import { TranslationsProvider } from './lib/translations-context';
import { AuthProvider } from './lib/auth-context';
import { RoleProvider } from './lib/role-context';
import { FeaturesProvider } from './components/FeatureGate';
import { ErrorBoundary } from './components/ErrorBoundary';
import { router } from './router';
import './lib/i18n';
import './globals.css';

if (import.meta.env.DEV) {
  // Reports elements wider than the viewport, which `overflow-x: clip` on <html> would
  // otherwise hide. Dynamic import so it is tree-shaken out of production builds.
  void import('./lib/dev-overflow-check').then((m) => m.startDevOverflowCheck());
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/*
      Outermost net: catches errors thrown by the providers themselves, which
      sit above the router and so are out of RouterErrorBoundary's reach.
    */}
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrandingProvider>
          <ThemeProvider>
            <MeasurementProvider>
              <TranslationsProvider>
                <AuthProvider>
                  <RoleProvider>
                    <FeaturesProvider>
                      <RouterProvider router={router} />
                      <Toaster position="top-right" richColors />
                    </FeaturesProvider>
                  </RoleProvider>
                </AuthProvider>
              </TranslationsProvider>
            </MeasurementProvider>
          </ThemeProvider>
        </BrandingProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
